<template>
  <div class="newsContainer">
    <News v-loading="loading" class="container newsInfo">
      <template v-slot:newsContent>
        <div class="breadcrumbBox">
        <span class="infoLocation">当前位置：</span><Breadcrumb :breadTitle="list" :breadList="breadList"  :separator="separator" />
        </div>
        <el-row :gutter="0" class="content">
          <el-col :sm="24" v-if="list">
            <div class="rich-text-wrapper">
              <h1>{{ list.title }}</h1>
              <div class="info">
                发布时间：{{ timeFormat(list.publish_time) }}
              </div>
              <NewsContent :newsInfo="list" />
            </div>
          </el-col>
        </el-row>
      </template>
      <template v-slot:rightMenu>
          <!-- <hotNews :title="title" :news="news" v-if="news&&title"/> -->
      </template>
    </News>
      <div class="firstBgBox pc"></div>
  </div>
</template>
<script>
import News from "@/components/news/News.vue";
// import hotNews from "@/components/news/hotNews.vue";
import { articleFindone,getArticleList} from "@/api/api.js";
import util from "@/libs/util.js";
import NewsContent from "@/components/news/news-Content";
import Breadcrumb from "@/components/breadcrumb";
import config from "../config.js";
export default {
  data() {
    return {
      list: null,
      id: null,
      loading: null,
      breadList: [],
      menu: null,
      news:null,
      title:null,
      menuId:null,
      separator:">"
    };
  },
  components: {
    NewsContent,
    Breadcrumb,
    News,
    // hotNews
  },
  created() {
   this.init()
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init(){
      console.log(this.$route);
    this.menu = config.menuList;
    this.menuId=this.$route.params.menuId
    this.id = this.$route.params.id;
    this.getNews();
    this.getHotNews();
    },
    updataDate() {
      this.breadList = [];
      this.getMenuByRoute();
      this.breadList.push({
        title: "文章详情",
        content: "",
        icon: "",
      });
    },
    getNews() {
      this.loading = true;
      articleFindone(this.id)
        .then((res) => {
          // 返回数据
          this.list = res.result;
          this.loading = false;
          this.updataDate();
        })
        .catch((err) => {
          // 异常情况
          console.log(err);
        });
    },
    getHotNews() {
      getArticleList({
        orgId:config.relationId,menu_pid:0,menu_id:this.menuId,pageNum:1,pageSize:4
      })
        .then(res => {
          // 返回数据
          this.news = res.result.list;
        })
        .catch(err => {
          // 异常情况
          console.log(err);
        });
    },
    getMenuByRoute() {
      // this.breadList.push({
      //   title: "首页",
      //   content: "../../portal",
      //   icon: "",
      // });
      if(this.menuId==1994){
        this.breadList.pop()
        this.breadList.push({
        title: "校内动态",
        content: "../../campusDynamic",
        icon: "",
      });
       this.breadList.push({
        title: "学校要闻",
        content: "../../news/1994?type=1&label=1",
        icon: "",
      });
      return;
      }else if(this.menuId==1995){
         this.breadList.pop()
        this.breadList.push({
        title: "校内动态",
        content: "../../campusDynamic",
        icon: "",
      });
       this.breadList.push({
        title: "学院风采",
        content: "../../news/1995?type=1&label=1",
        icon: "",
      });
      return;
      }else if(this.menuId==2010){
        this.breadList.pop()
        this.breadList.push({
        title: "成果展示",
        content: "../../resultsShow",
        icon: "",
      });
       this.breadList.push({
        title: "成果展示",
        content: "../../news/2010?type=1&label=2",
        icon: "",
      });
      return;
      }else if(this.menuId==1998){
        this.breadList.pop()
        this.breadList.push({
        title: "成果展示",
        content: "../../resultsShow",
        icon: "",
      });
       this.breadList.push({
        title: "优秀教师",
        content: "../../news/1998?type=2&label=2",
        icon: "",
      });
      return;
      }else if(this.menuId==1999){
        this.breadList.pop()
        this.breadList.push({
        title: "成果展示",
        content: "../../resultsShow",
        icon: "",
      });
       this.breadList.push({
        title: "示范课堂",
        content: "../../news/1999?type=0&label=2",
        icon: "",
      });
      return;
      }else if(this.menuId==2000){
        this.breadList.pop()
        this.breadList.push({
        title: "成果展示",
        content: "../../resultsShow",
        icon: "",
      });
       this.breadList.push({
        title: "党建活动",
        content: "../../news/2000?type=1&label=2",
        icon: "",
      });
      return;
      }else if(this.menuId==2003){
        this.breadList.pop()
        this.breadList.push({
        title: "制度文件",
        content: "../../systemFile",
        icon: "",
      });
       this.breadList.push({
        title: "上级文件",
        content: "../../news/2003?type=2&label=3",
        icon: "",
      });
      return;
      }else if(this.menuId==2004){
        this.breadList.pop()
        this.breadList.push({
        title: "制度文件",
        content: "../../systemFile",
        icon: "",
      });
       this.breadList.push({
        title: "学校文件",
        content: "../../news/2004?type=2&label=3",
        icon: "",
      });
      return;
      }
      //根据路由判断左侧菜单的当前激活
      for (var i = 0; i < this.menu.length; i++) {
        var menu = this.menu[i];
        if (menu.isActive(this.$route)) {
          this.breadList.push(menu);
          this.title=menu.title
          return;
        }
        for (var j = 0; j < menu.subMenuList.length; j++) {
          var subMenu = menu.subMenuList[j];
          if (subMenu.isActive(this.$route)) {
            // this.breadList.push(menu);
            this.breadList.push(subMenu);
            this.title=menu.title
            return;
          }
          if (subMenu.subMenuList) {
            for (var z = 0; z < subMenu.subMenuList.length; z++) {
              var lastMenu = subMenu.subMenuList[z];
              if (lastMenu.isActive(this.$route)) {
                this.breadList.push(menu);
                this.breadList.push(subMenu);
                this.breadList.push(lastMenu);
                this.title=menu.title
                return;
              }
            }
          }
        }
      }
    },
    timeFormat(value) {
      return util.timeFormat(value, "yyyy-MM-dd");
    },
  },
};
</script>
<style lang="scss" scoped>
.newsInfo{
  position: relative;
  z-index: 9;
}
.firstBgBox{
  position: absolute;
  width: 100%;
  height: 700px;
  top: 0;
  background-image: url("~@/assets/images/kcsz/topBg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
  overflow-x: hidden;
}
.newsInfo {
  min-height: 100%;
  padding-top: 20px;
}
.content {
  margin-top: 20px;
  padding: 20px 30px;
  background-color: #fff;
  margin-bottom: 80px;
  border: 1px solid #efeff7;
}
.rich-text-wrapper h1 {
  font-size: 22px;
  line-height: 32px;
}

.rich-text-wrapper .info {
  margin: 20px 0;
  font-size: 12px;
  line-height: 16px;
  color: #888;
}
.infoLocation {
  float: left;
  font-size: 14px;
  line-height: 19px;
  vertical-align: middle;
}
@media (max-width: 767px) {
  .breadcrumbBox{
    padding-left: 15px;
    padding-top: 20px;
  
  }
  .newsInfo{
  position: unset;
}
  .container{
    padding: 0px;
  }
  .content{
    margin-top:0px;
    margin-bottom:20px;
    padding: 20px 15px 0px;
    border: none;
  }
  .rich-text-wrapper {
    padding: 0;
    background-color: unset;
    border: unset;
  }

  .rich-text-wrapper h1 {
    font-size: 18px;
    line-height: 30px;
  }

  .rich-text-wrapper .info {
    margin: 10px 0;
  }
}
</style>